import { render, staticRenderFns } from "./PRCompany.vue?vue&type=template&id=dd607b10&scoped=true&"
import script from "./PRCompany.vue?vue&type=script&lang=js&"
export * from "./PRCompany.vue?vue&type=script&lang=js&"
import style0 from "./PRCompany.vue?vue&type=style&index=0&id=dd607b10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd607b10",
  null
  
)

export default component.exports